import { render, staticRenderFns } from "./SliCustomerSelect.vue?vue&type=template&id=273e7c91"
import script from "./SliCustomerSelect.vue?vue&type=script&lang=js"
export * from "./SliCustomerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports